module.exports = __webpack_public_path__ + "static/img/market03.a7a41b57.png";